/** @typedef {{ date_from?: string, date_to?: string }} BlockedRow */

export function toISODate(date) {
  if (!date) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function fromISODate(value) {
  if (!value) return null;
  const [year, month, day] = String(value).split('T')[0].split('-').map(Number);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day, 12, 0, 0);
}

/**
 * Stay uses half-open nights: [start_date, end_date) — end_date is checkout (not a stay night).
 * Blocked rows use inclusive night range [date_from, date_to].
 */
export function stayNightsOverlapBlocked(startISO, checkoutISO, blockedDates) {
  if (!startISO || !checkoutISO || checkoutISO <= startISO) return true;
  const start = fromISODate(startISO);
  const checkout = fromISODate(checkoutISO);
  if (!start || !checkout) return true;
  const lastNight = new Date(checkout.getFullYear(), checkout.getMonth(), checkout.getDate() - 1, 12, 0, 0);
  if (lastNight < start) return true;

  for (const b of blockedDates) {
    const bFrom = fromISODate(String(b.date_from || '').split('T')[0]);
    const bTo = fromISODate(String(b.date_to || '').split('T')[0]);
    if (!bFrom || !bTo) continue;
    if (start <= bTo && lastNight >= bFrom) return true;
  }
  return false;
}

/**
 * True if this calendar day cannot be used as check-in (blocked night or before today).
 */
export function isNightBlockedAsCheckIn(date, blockedDates, todayStart) {
  const iso = toISODate(date);
  const dayStart = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
  if (dayStart < todayStart) return true;
  return blockedDates.some((b) => {
    const bFrom = String(b.date_from || '').split('T')[0];
    const bTo = String(b.date_to || '').split('T')[0];
    return iso >= bFrom && iso <= bTo;
  });
}

/**
 * @param {BlockedRow[]} blockedDates
 * @returns {{ start: Date, end: Date }[]}
 */
export function blockedIntervalsForPicker(blockedDates) {
  return blockedDates
    .map((b) => {
      const from = fromISODate(String(b.date_from || '').split('T')[0]);
      const to = fromISODate(String(b.date_to || '').split('T')[0]);
      if (!from || !to) return null;
      return { start: from, end: to };
    })
    .filter(Boolean);
}
